import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { Navigation_Service } from 'app/core/navigation/navigation.service';
import { User_Service } from 'app/core/user/user.service';

@Injectable({
    providedIn: 'root'
})
export class DashboardDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(
        private _navigation_service: Navigation_Service,
        private _us: User_Service
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Use this resolver to resolve initial mock-api for the application
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        // Fork join multiple API endpoint calls to wait all of them to finish
        return forkJoin([
            this._navigation_service.get(),
            // this._us.get()
        ]);
    }
}
